import { Component } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, RouterLink],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  mobileMenuOpen = false;
  readonly adminPortalUrl = 'https://admin.dsgeniuspublicschool.com';

  scrollToHero($event?: Event) {
    $event?.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  openAdminPortal($event: Event) {
    $event.preventDefault();
    window.open(this.adminPortalUrl, '_blank', 'noopener,noreferrer');
    this.mobileMenuOpen = false;
  }
}
